import { Component, OnInit, AfterViewChecked, Input, ElementRef, EventEmitter, Output, DoCheck, ViewChildren, QueryList, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, FormArray } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LoggerService } from '@kpmg-tax/core';
import { Observable, of, Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, catchError, tap } from 'rxjs/operators';
import { LoadingIndicatorService, ToastrService } from '@kpmg-tax/ui';
import { DatePipe, formatDate } from '@angular/common';
import { RightSideDrawerService } from '../shared/right-side-drawer/right-side-drawer.service';
import { SessionService } from '../shared/session-service/session.service';
import { SESSION_CONST } from '../shared/constants/session-constants';
import { BaseResponse } from '../shared/models/base-response.model';
import { Engagement } from 'src/app/shared/models/engagement/engagement.model';
import { Messages } from '../shared/constants/messages';
import { ROUTE_URL } from '../shared/constants/route-constants';
import { role } from '../shared/constants/role-enum';
import { WhiteSpaceValidator } from '../core/validators/whitespace-validator';
import { GetClientsResponse } from 'src/app/shared/models/get-clients-response.model';
import { AdminClientUsersService } from 'src/app/admin/admin-client-users/admin-client-users.service';
import { APP_CONSTANTS, MANAGE_CLIENT_ADMIN_USER } from 'src/app/shared/constants/app-constants';
import { EngagementFlagOptions, EngagementFlag } from '../shared/constants/engagement-flag';
import { CustomDropDown } from 'src/app/shared/models/custom-dropdown.model';
import { encodeText, decodeText, stringNotEmpty } from 'src/app/shared/lib/custom-tools';
import { UserDetails } from '../core/models/user-details.model';
import { UserDataService } from '../core/services/user-data.service';
import { TopNavigationService } from '../shared/navigation/top-navbar/top-nav.service';
import { ManageStudyService } from './manage-study.service';
import { ManageClientUsersService } from './manage-client-users/manage-client-users.service';
import { StudyLandingService } from '../study-home/study-landing/study-landing.service';
import { TooltipOptions } from 'ng2-tooltip-directive';
import { TaxPeriod } from 'src/app/shared/models/engagement/TaxPeriod';
@Component({
    selector: 'manage-study',
    templateUrl: './manage-study.component.html',
    styleUrls: ['./manage-study.component.scss']
})
export class ManageStudyComponent implements OnInit, DoCheck {
    emailReminderFrequencyOptions: any;
    engagementFlagOptions: EngagementFlagOptions;
    engagementFlag = EngagementFlag;
    targetForm: FormGroup;
    subject: Subject<any> = new Subject();
    engagements: any;
    engagementNumberValidators = {
        liveEngagement: [
            Validators.required,
            Validators.minLength(10),
            Validators.maxLength(10),
            Validators.pattern(/^[0-9]\d*$/)
        ],
        demoEngagement: [
            Validators.required,
            Validators.maxLength(100),
            Validators.pattern('^[a-zA-Z0-9]+$')
        ]
    }
    engagementNameError: boolean = false;
    isDGclient: boolean = false;
    getSearchlistUserNames: any;
    engagementCreated: any;
    notfound: string = 'Sorry, user name not found!';
    noResults: boolean;
    kpmgUsers: any = [
        // blank user to pass in to prevent observable error
        {
            firstName: 'rdetest',
            lastName: 'rdetest',
            email: 'rdetest@kpmg.com',
        },
    ];
    kpmgUsersSelected: any = [];
    engagementManagerSelected: any = [];
    engagementPartnerSelected: any = [];
    engagementManagerSelectedId: number = 0;
    engagementPartnerSelectedId: number = 0;
    clients: GetClientsResponse;
    clientUsers: any;
    clientUsersSelected: any = [];
    clientAdminSelected: any = [];
    removeClientAdminSelected: any = [];
    clientIdSelected: number = 0;
    engagementUsers: any = [];
    isSearchKPMG: boolean;
    startDateError: boolean = false;
    defaultStartDate: Date;
    isStartDateRequired: boolean = false;
    isEndDateRequired: boolean = false;
    startDate: Date = null;
    maxDate: Date = new Date(2999, 25, 12);
    engagementClient: string = '';
    minDate: Date = new Date();
    @ViewChild('dpStart', { static: true }) dpStart;
    @ViewChild('dpEnd', { static: true }) dpEnd;
    isDisabled: boolean = false;
    isClientSelected: boolean = false;
    clientNameChanged: Subject<string> = new Subject<string>();
    engagementNameChanged: Subject<string> = new Subject<string>();
    RCSWatsonQuestion = new Map<number, boolean>();
    RCSWatsonvalues = new Map<string, boolean>();
    RCSContractvalues = new Map<string, boolean>();
    enableRCSWatson: boolean = false;
    enableRCSContract: boolean = false;
    RCSWatsonCount: number = 0;
    RCSquestiondata: any[] = [];
    @ViewChildren('questions') private questions: QueryList<ElementRef>;
    @Output() drawerWidth = new EventEmitter<string>();

    @Input() mandatoryindicator: boolean;
    isClientMode: boolean = false;
    reminderValue: number = 0;
    studyFlagOptionId: number = 2;
    demoClientUsers: any[];
    createEngagementFormSubmitCount: number = 0;
    noResultflag: boolean;
    isHidden: boolean = true;
    isHidden2: boolean = true;
    RCSWatsonData: any;
    questiondata: any;
    RCSContractData: any;
    questiondataContract: any;
    showyesWError: boolean = false;
    RCSContractDataDup: any;
    RCSWatsonDataDup: any;
    RCSContractQuestion = new Map<number, boolean>();
    RCSContractcount: number = 0;
    finalEngagementManagerstrKPMG: string;
    engagementManagerKPMGUser: boolean = false;
    finalEngagementPartnerstrKPMG: string;
    engagementPartnerKPMGUser: boolean = false;
    finalAddKPMGUserstrKPMG: string;
    engagementAddKPMGUser: boolean = false;
    taxYear: string = '';
    emailReminderText = 'No reminders';
    dropdownWidth = '19em';
    emailReminderOptions: CustomDropDown[] = []; //string[] = [];
    canSMEAddProjects: boolean = false;
    canSMEAddEmployees: boolean = false;
    currentUser = this.sessionService.getSession('userName');
    currentUserId = Number(this.sessionService.getSession('currentUserId'));
    @ViewChild('custSearch') defaultClientName: ElementRef;
    userDetails: any = [];
    totalEngCounts: number;
    isDemoClickedFirst: boolean = false;
    isCreateOrEditStudy: boolean = false;
    roleId: number;
    championRole: number = role.champion;
    clientManagerRole: number = role.clientManager;
    respondentRole: number = role.respondent;
    adminRole: number = role.admin;
    clientAdmin: number = role.clientAdmin;
    engagementName: string;
    clientName: string;
    engagementNumber: string;
    isArchivedStudy = false;
    check = false;
    RCSContractTouched: boolean;
    RCSWatsonTouched: boolean;
    endDate: Date;
    user: UserDetails;
    rowEditData: any;
    subscriptions: Subscription[] = [];
    selectedTab = { selectStudyDetails: true, selectTaxYear: false, selectClientUsers: false, selectStudyConfiguration: false, selectAccessPermission: false };
    navigationString: string = "";
    isCreateStudy = false;
    readyToSubmit = false;
    engagementId: number;
    clientId: number;
    engagement: Engagement;
    engagementManagerToDisplay = '';
    engagementPartnerToDisplay = '';
    initialengagementManagerId: any;
    initialengagementPartnerId: any;
    noengagementManager = false;
    noengagementPartner = false;
    isRCSContractEditable = true;
    isRCSContractEnabled = false;
    rcsWatsonTitleMessage = 'RCS with Watson access {0}enabled';
    rcsContractTitleMessage = 'RCS Contract Analysis (eBrevia) access {0}enabled';
    actualreminderFrequencyValue = 0;
    isReadonlyENo = false;
    kpmgUsersSelectedbckup: any[] = [];
    clientUsersSelectedbckup: any[] = [];
    changed = new Map<string, boolean>();
    defaultEndDate: Date;
    engagementManager: any;
    engagementPartner: any;
    studyClientManagers: any[] = [];
    studyConfigurationSettings = {
        checkclientmanagerqreinsight: false,
        checksmetimesurveyupload: false,
        checksmetimesurveyAddEmployee: false,
        checksmetimesurveyaddproject: false,
        checksmetimesurveyaddactivities: false,
        checksmetimesurveyaddnqa: false,
        checksmetimesurveyaddnwt: false,
        checksmetimesurveysubmitcondition: false,
        checksmeprojectsurveysubmitcondition: false,
        checksmetimesurveysubmitconditionwithdoc: false,
        isEnableAgileAnalyzer: false,
        checksmeatleastonecheckboxselectedsubmitcondition: false,
        checksmeuploaddocumentexpensesurvey: false,
        checksmeexpensesurveysubmitconditionwithdoc: false,
        checksmeaddprojectexpensesurvey: false,
    };
    toolTipOptions: TooltipOptions = {
        placement: "right"
    } as TooltipOptions;
    guidance_kpmg_user = MANAGE_CLIENT_ADMIN_USER.GUIDANCE_TOOLTIP_KPMG_USER;
    roleEnum: typeof role = role;

    step = { selectStudyDetails: 1, selectClientUsers: 2, selectStudyConfiguration: 3, selectAccessPermission: 4 }
    enableBulkUser: boolean = false;
    taxPeriods: Array<TaxPeriod> = [];
    taxTargetForm: FormGroup;
    isTaxPeriodReady = false;
    isTaxPeriodLoad = false;
    dateErrorMessage = '';
    clientMasterRefId: number;
    canAddClientUsers: boolean;
    isSetToFavorite = false;

    constructor(
        public rightSideDrawerService: RightSideDrawerService,
        public _manageStudyService: ManageStudyService,
        public sessionService: SessionService,
        public _toasterService: ToastrService,
        public datepipe: DatePipe,
        private router: Router,
        private formBuilder: FormBuilder,
        public datePipe: DatePipe,
        public _clientUserService: AdminClientUsersService,
        private _userDataService: UserDataService,
        public _topNavigationService: TopNavigationService,
        private _activatedRoute: ActivatedRoute,
        private _loaderService: LoadingIndicatorService,
        private _studyLandingService: StudyLandingService
    ) {

        this.toolTipOptions.tooltipClass = "mapping-text-tooltip-KpmgUser";
        this.getEmailReminderFrequency();
        this.emailReminderFrequencyOptions = this._manageStudyService.getEmailReminderFrequencyOptions();
        this.engagementFlagOptions = new EngagementFlagOptions();
        this.subscriptions.push(this._userDataService.userDetails$.subscribe(userData => {
            this._loaderService.display(true, true);
            if (userData) {
                this.user = userData;
            }
            this._loaderService.display(false);
        }));
        this.subscriptions.push(
            this._userDataService.userDetails$.subscribe(({ roleId }) => {
                this.roleId = roleId
            })
        )
        this.subscriptions.push(
            this._studyLandingService.studyNavigation.subscribe(x => this._manageStudyService.navigationScreen = x)
        )
        this.getRouteExtras();
    }

    getEmailReminderFrequency(): void {
        const emailFrequencies = APP_CONSTANTS.EMAIL_REMINDER_FREQUENCY;
        emailFrequencies.forEach((item, index) => {
            this.emailReminderOptions.push({ id: index, value: item, isDisabled: index === 0 ? true : false });
        });
    }

    get isClientAdmin(): boolean {
        return this.roleId === this.clientAdmin;
    }

    get f() {
        return this.targetForm?.controls;
    }

    resetEngagementData(engagementId) {
        let endDate = '';
        this._loaderService.display(true, true);
        this._manageStudyService.GetEngagementById(engagementId, true).subscribe(
            (data: BaseResponse) => {
                this.sessionService.setSession('engagementId', data.result.engagementId.toString());
                this.sessionService.setSession('clientId', data.result.clientId.toString());
                this.sessionService.setEngagementNameAndNumber(data.result.engagementName.toString(), data.result.engagementNumber.toString());
                this.sessionService.setEngagementName(data.result.engagementName.toString());
                this.sessionService.setSession('clientName', data.result.clientName.toString());

                if (data.success != null && data.success) {
                    let engagement: any = data;
                    this.engagement = data.result;
                    this.clientId = data.result.clientId;
                    this.isArchivedStudy = data.result.isArchived;
                    // this.isSetToFavorite = data.result.isFavorite;
                    this.engagementNumber = data.result.engagementNumber;
                    this.engagementName = data.result.engagementName ? data.result.engagementName.trim() : null;
                    this.engagementId = data.result.engagementId;
                    this.clientMasterRefId = data.result.clientMasterRefId;
                    this.canAddClientUsers = (this.clientMasterRefId == null || this.clientMasterRefId == undefined || this.clientMasterRefId <= 0);

                    if (this.clientMasterRefId != null && this.clientMasterRefId != undefined && this.clientMasterRefId > 0) {
                        this._manageStudyService.getKpmgUsersForDGClient(this.clientId);
                    } else {
                        if (this.roleId !== role.clientAdmin)
                            this._manageStudyService.getKpmgUsers();
                    }
                    this.check = data.result.isArchived;
                    const engagementManagerId = data.result.engagementManager;
                    this.initialengagementManagerId = engagementManagerId;
                    this.engagementManagerSelectedId = engagementManagerId;
                    const engagementPartnerId = data.result.engagementPartner;
                    this.initialengagementPartnerId = engagementPartnerId;
                    this.engagementPartnerSelectedId = engagementPartnerId;
                    this.studyFlagOptionId = this.getStudyFlagOptionId(data.result.engagementFlagId);
                    this.emailReminderText = data.result.reminderFrequency === 0 ?
                        'No reminders' : this.emailReminderOptions[data.result.reminderFrequency].value;
                    this._manageStudyService.kpmgUsersDataSource$.subscribe(users => {
                        if (users && users.result) {
                            this.kpmgUsers = users;
                            const engagementManager = this.kpmgUsers.result.filter(x => x.userId === +engagementManagerId);
                            const engagementPartner = this.kpmgUsers.result.filter(x => x.userId === +engagementPartnerId);
                            this.engagementManagerToDisplay = engagementManager && engagementManager[0] ? engagementManager[0].displayName : ''; // + " - " +engagementManager[0].email
                            this.engagementPartnerToDisplay = engagementPartner && engagementPartner[0] ? engagementPartner[0].displayName : ''; // + " - " +engagementPartner[0].email
                            if (this.engagementManagerToDisplay === '') {
                                this.noengagementManager = true;
                            }
                            if (this.engagementManagerToDisplay === '') {
                                this.noengagementPartner = true;
                            }
                            this.targetForm?.controls.engagementManager.setValue(this.engagementManagerToDisplay);
                            this.targetForm?.controls.engagementPartner.setValue(this.engagementPartnerToDisplay);
                        }
                    });
                    this.getClientUsers(this.clientId);
                    this.resetFormData(data.result);
                    this.bindUsers(
                        data.result.users
                    );
                    this.changed['KPMG'] = false;
                    this.changed['client'] = false;

                    this.reminderValue = data.result.reminderFrequency;
                    this.engagementManager = data.result.engagementManager;
                    this.engagementPartner = data.result.engagementPartner;
                    this.taxYear = data.result.taxYear;
                    this.studyConfigurationSettings.checkclientmanagerqreinsight = data.result.canClientManagerQreInsight;
                    this.studyConfigurationSettings.checksmeprojectsurveysubmitcondition = data.result.canSMESubmitProjectSurvey;
                    this.studyConfigurationSettings.checksmetimesurveyAddEmployee = data.result.canSMEAddEmployees;
                    this.studyConfigurationSettings.checksmetimesurveyaddactivities = data.result.canSMEAddActivities;
                    this.studyConfigurationSettings.checksmetimesurveyaddnqa = data.result.canSMEAddNQA;
                    this.studyConfigurationSettings.checksmetimesurveyaddnwt = data.result.canSMEAddNWT;
                    this.studyConfigurationSettings.checksmetimesurveyaddproject = data.result.canSMEAddProjects;
                    this.studyConfigurationSettings.checksmetimesurveysubmitcondition = data.result.canSMESubmitTimeSurvey;
                    this.studyConfigurationSettings.checksmetimesurveyupload = data.result.canSMEUploadDocument;
                    this.studyConfigurationSettings.checksmeatleastonecheckboxselectedsubmitcondition = data.result.canSMESubmitTimeSurveyWithSelection;
                    this.studyConfigurationSettings.isEnableAgileAnalyzer = data.result.isEnableAgileAnalyzer;
                    this.studyConfigurationSettings.checksmetimesurveysubmitconditionwithdoc = data.result.canSMESubmitTimeSurveyWithDocument;
                    this.studyConfigurationSettings.checksmeuploaddocumentexpensesurvey = data.result.canSMEUploadDocumentExpenseSurvey;
                    this.studyConfigurationSettings.checksmeexpensesurveysubmitconditionwithdoc = data.result.canSMESubmitExpenseSurveyWithDocument;
                    this.studyConfigurationSettings.checksmeaddprojectexpensesurvey = data.result.canSMEAddProjectsExpenseSurvey;
                    this.navigateToSurveyScreen(this._manageStudyService.navigationScreen)
                    this._loaderService.display(false);

                } else {
                    this._toasterService.setErrorMessage(Messages.Home.GetEngagementFailure);
                    this._loaderService.display(false);
                }
            });
    }

    getTaxPeriods(engagementId) {
        this._manageStudyService.getTaxPeriods(engagementId).subscribe(data => {
            this.formatTaxPeriods(data);
            this._loaderService.display(false);
        });
    }

    bindUsers(users: any) {
        users.forEach((user: any) => {
            if (user.roleId === role.admin) {
                this.kpmgUsersSelected.push(user);
                this.kpmgUsersSelectedbckup.push(user);
            } else if (user.roleId === role.clientManager) {
                this.clientUsersSelected.push(user);
                this.clientUsersSelectedbckup.push(user);
            }
        });
        this.sortedUsers();
    }

    sortedUsers() {
        this.kpmgUsersSelected = this.kpmgUsersSelected.sort((a, b) =>
            a.userName > b.userName ? 1 : -1
        );
    }


    public resetFormData = (data: any) => {
        let endDate = '';
        this.rowEditData = data;
        this.clientName = this.rowEditData.clientName;
        this.isArchivedStudy = this.rowEditData.isArchived;
        this.engagementNumber = this.rowEditData.engagementNumber;
        this.engagementName = this.rowEditData.engagementName ? this.rowEditData.engagementName.trim() : null;
        this.engagementId = this.rowEditData.engagementId;
        this.check = this.rowEditData.isArchived;
        this.targetForm = new FormGroup({
            clientName: new FormControl(
                this.rowEditData.clientName
                    ? this.rowEditData.clientName.trim()
                    : null,
                [Validators.maxLength(100)]
            ),
            engagementName: new FormControl(this.engagementName
                , [Validators.maxLength(100)]),
            engagementManager: new FormControl(this.engagementManagerToDisplay ? this.engagementManagerToDisplay : ''
                , [Validators.required]
            ),
            engagementPartner: new FormControl(this.engagementPartnerToDisplay ? this.engagementPartnerToDisplay : ''
                , [Validators.required]
            ),
            engagementNumber: new FormControl(this.engagementNumber
                , this.studyFlagOptionId === this.engagementFlag.Demo ? this.engagementNumberValidators.demoEngagement : this.engagementNumberValidators.liveEngagement
            ),
            engagementEmailFrequency: new FormControl(
                this.rowEditData.reminderFrequency,
                Validators.pattern('^([0-9]|1[0-4])$')
            ),
            totalHours: new FormControl(this.rowEditData.totalHours),
            standardNonWorkingHours: new FormControl(this.rowEditData.standardNonWorkingHours),
            priorYearQre: new FormControl(this.rowEditData.priorYearQre)
        });

        this.actualreminderFrequencyValue = this.rowEditData.reminderFrequency;
        this.isReadonlyENo = false;

        if (stringNotEmpty(this.rowEditData.engagementNumber)) {
            this.isReadonlyENo = true;
        }

        this.isRCSContractEditable = this.rowEditData.isRCSContractEditable;
        this.questiondata = this.rowEditData.rcsWatsonAnalysis;
        this.questiondataContract = this.rowEditData.rcsContractAnalysis;
        this.isRCSContractEnabled = this.rowEditData.isRCSContractAnalysisEnabled;
        this.enableRCSWatson = this.rowEditData.isRCSWatsonEnabled;
        this.enableRCSContract = this.rowEditData.isRCSContractAnalysisEnabled;

        if (this.rowEditData.isArchived) {
            this.targetForm.disable();
        }

        if (!this.rightSideDrawerService.manageClientUserData) {
            this.rightSideDrawerService.manageClientUserData = {
                clientId: this.clientId,
                clientName: this.rowEditData.clientName ? this.rowEditData.clientName.trim() : null,
                isManageClientUser: false
            };
        } else if (this.rightSideDrawerService.manageClientUserData.isManageClientUser) {
            this.rightSideDrawerService.manageClientUserData = {
                clientId: this.clientId,
                clientName: this.rowEditData.clientName ? this.rowEditData.clientName.trim() : null,
                isManageClientUser: false
            };
        } else {
            this.rightSideDrawerService.manageClientUserData = null;
        }
    };

    private getStudyFlagOptionId(id: number) {
        if (id && id >= 1 && id <= 3) {
            return id;
        } else {
            return this.studyFlagOptionId = null;
        }
    }
    ngDoCheck() {
        let value =
            this.targetForm?.controls.engagementNumber.value ||
            this.targetForm?.controls.clientName.value ||
            this.targetForm?.controls.engagementName.value ||
            this.targetForm?.controls.engagementEmailFrequency.value ||
            this.kpmgUsersSelected.length > 0 ||
            this.clientUsersSelected.length > 0 ||
            this.engagementManagerSelectedId > 0 ||
            this.engagementPartnerSelectedId > 0;
    }

    ngOnInit() {
        this._activatedRoute.paramMap.subscribe(params => {
            if (params && params.has(APP_CONSTANTS.STUDY_ID)) {
                this.engagementId = Number(params.get(APP_CONSTANTS.STUDY_ID));
                this._topNavigationService.setStudyNav(true);
                this.isCreateStudy = false;
                this.sessionService.setSession('engagementId', this.engagementId);
                this.resetEngagementData(this.engagementId);
                this.getTaxPeriods(this.engagementId);
                this.isDisabled = true;
            }
            else {
                this._topNavigationService.setStudyNav(false);
                this.isCreateStudy = true;

                this._manageStudyService.getKpmgUsers();
                this.getKPMGUsers();
            }
        });
        if (!this.engagementId) {
            this.getInitialTaxPeriodRow();
            this.bindTaxperiodFormArray();
        }
        this.getClientNames();
        this.isClientMode =
            this.sessionService.getSession(SESSION_CONST.ISCLIENTMODE) === 'true';
        if (this.isClientMode) {
            this.engagementClient = this.rightSideDrawerService.singleRowAddData;
        }
        this.targetForm = this.formBuilder.group({
            clientName: [
                '',
                [Validators.required, Validators.maxLength(100)],
            ],
            engagementName: [
                '',
                [Validators.required, Validators.maxLength(100), WhiteSpaceValidator.cannotContainSpace],
            ],

            engagementNumber: ['', this.studyFlagOptionId === this.engagementFlag.Demo ? this.engagementNumberValidators.demoEngagement : this.engagementNumberValidators.liveEngagement],

            engagementEmailFrequency: ['3', [Validators.pattern('^([0-9]|1[0-4])$')]],
            totalHours: ['2096'],
            standardNonWorkingHours: ['120'],
            priorYearQre: []
        });
        this.drawerWidth.emit('calc(61vw - 100px)');
    }

    getRouteExtras() {
        let xtraPram = this.router.getCurrentNavigation();
        if (xtraPram) {
            this._manageStudyService.navigationScreen = xtraPram.extras.state?.menu;
            this.enableBulkUser = xtraPram.extras.state?.enableBulkUser;
        }
    }

    onEmailFrequencySelected(selectedOption: CustomDropDown): void {
        if (selectedOption !== null) {
            const emailFrequency = this.emailReminderOptions.find(item => item.id === selectedOption.id);
            this.reminderValue = emailFrequency && emailFrequency.value.includes(selectedOption.id.toString()) ? emailFrequency.id : 0;
            this.emailReminderText = emailFrequency.value.toString();
            this.isChanged();
        }
    }

    //Waits until all keystrokes have been entered before checking if an engagement name exists under the current entered client
    onClientNameChanged(clientName: string) {
        if (this.clientNameChanged.observers.length === 0) {
            this.clientNameChanged.pipe(debounceTime(250), distinctUntilChanged()).subscribe(() => {
                this.verifyClientWithID(this.engagementClient);
            });
        } else {
            this.isClientSelected = false;
        }
        this.clientNameChanged.next(clientName);
    }

    onEngagementNameChanged(engName: string) {
        if (this.engagementNameChanged.observers.length === 0) {
            //Once 250 milliseconds has passed after last keystroke, if the input is different from last call, check the engagement name.
            this.engagementNameChanged.pipe(debounceTime(250), distinctUntilChanged()).subscribe(() => {
                this.checkEngagementName();
            });
        }
        this.engagementNameChanged.next(engName);
    }

    onEngagementNumberChanged(engNumber: string) {
        if (this.engagementNumber.length === 0) {
            this.isDisabled = true;
        }
        this.engagementNumber = engNumber;
        this.isDisabled = false;
    }

    isChanged() {
        if (!this.isCreateStudy) {
            const rowEditData = this.rowEditData;
            if (this.check !== rowEditData.isArchived && this.isArchivedStudy) {
                this.isDisabled = false;
                this.targetForm.enable();
            } else if (this.changed['KPMG'] || this.changed['client']) {
                this.isDisabled = false;
            } else if (
                this.reminderValue !== rowEditData.reminderFrequency
                || this.check !== rowEditData.isArchived
                || (this.RCSWatsonTouched && this.RCSWatsonCount == 3)
                || (this.RCSContractTouched && this.RCSContractcount == 2)) {
                this.isDisabled = false;
            } else if (
                (this.engagementManagerSelectedId > 0 && this.engagementManagerSelectedId != this.initialengagementManagerId) &&
                (this.engagementPartnerSelectedId > 0 && this.engagementPartnerSelectedId != this.initialengagementPartnerId)) {
                this.isDisabled = false;
            } else {
                this.isDisabled = true;
            }
        }
    }

    // check if engagement name already exists
    checkEngagementName() {
        let engagementName = this.targetForm.get('engagementName').value || '';
        if (engagementName && engagementName.trim().length > 0 && this.clientIdSelected !== 0) {
            this._manageStudyService.CheckEngagementName(engagementName.trim(), this.clientIdSelected).subscribe((data: BaseResponse) => {

                if (this.isCreateStudy) {
                    this.engagementNameError = data.result;
                }
                else {
                    this.isDisabled = false;
                }
            });
        } else {
            this.engagementNameError = false;
        }
    }

    onHoursChanged() {
        const maxTotalhours: number = 3500;
        const maxStandardNWH: number = 2096;
        const maxEmployeeWorkingHours: number = 8784;
        if (!this.isCreateStudy) {
            this.isDisabled = (this.targetForm?.controls.totalHours.value > maxTotalhours
                || this.targetForm?.controls.standardNonWorkingHours.value > maxStandardNWH
                || this.targetForm?.controls.employeeWorkingHourThreshold.value > maxEmployeeWorkingHours);
        }
    }

    // get KPMG users
    getKPMGUsers(): void {
        this._manageStudyService.kpmgUsersDataSource$.subscribe(kpmgUsersResponse => {
            if (kpmgUsersResponse && kpmgUsersResponse.result) {
                this.kpmgUsers = kpmgUsersResponse;
            }
        });
    }

    // get client users
    getClientUsers(clientId: number) {
        this.clientIdSelected = clientId;
        this._manageStudyService.GetClientUsers(clientId).subscribe(
            (data: BaseResponse) => {
                this.clientUsers = data.result;
            });
    }

    // Filter clientUsers autosuggest
    private searchClientUsers(term: any): Observable<any> {
        if (this.clientUsers) {
            return of(
                this.clientUsers.filter(
                    item => item.displayName.toLowerCase().includes(term.toLowerCase()),
                    //||
                    //item.email.toLowerCase().includes(term.toLowerCase()),
                ),
            );
        } else {
            return of([]);
        }
    }

    // Search KPMG Users
    searchKPMG(bool: boolean) {
        this.isSearchKPMG = bool;
    }

    // format for employees search
    kpmgUserFormatter = (result: any) => '';
    clientUserFormatter = (result: any) => '';

    removeUserFromEngagement(row) {
        this.engagementUsers.splice(
            this.engagementUsers.findIndex(item => item.userName === row.userName),
            1,
        );
        this.engagementUsers = [...this.engagementUsers];
    }

    // Filter clients autosuggest
    private searchClients(term: any): Observable<any> {
        if (this.clients && this.clients.result && this.clients.result.length !== 0) {
            return of(
                this.clients.result.filter(item =>
                    item.clientName.toLowerCase().includes(term.toLowerCase()),
                ),
            );
        } else {
            return of([]);
        }
    }

    // get clients
    getClientNames() {
        this._manageStudyService.clientUsersDataSource$.subscribe(clientData => {
            if (clientData && clientData.result) {
                this.clients = clientData;
            }
            if (this.isClientMode) {
                this.showClientUsers(this.engagementClient);
            }
        });
    }

    // format for clients search
    clientFormatter = (result: any) =>
        result && result.clientName ? result.clientName.trim() : null

    // Autosuggest for Existing Client Names
    searchExistingClients = (searchPhrase$: Observable<any>) =>
        searchPhrase$.pipe(debounceTime(150), distinctUntilChanged(), // Only continue if the current search term is different that it was before the user started typing
            tap(term => {
                // Remove "no results" message in case it was displayed from the previous search
                this.noResults = false;
                this.noResultflag = false;
            }),
            switchMap(term => {
                if (term !== '') {
                    // Process the search term entered
                    return this.searchClients(term).pipe(switchMap(data => {
                        this.engagementClient = term;
                        return of(data);
                    }),
                        catchError(() => {
                            this.noResults = true;
                            return of([]);
                        }),
                    );
                } else {
                    return of([]);
                }
            }),
        )

    onClientSelected($event: any) {
        var clientName = $event.item.clientName;
        const DGClientExists = this.clients.result.some(item =>
            item.clientName.toLowerCase() === clientName.toLowerCase() &&
            item.masterRefId != null &&
            item.masterRefId !== undefined &&
            item.masterRefId > 0
        );
        this.isDGclient = ($event.item.masterRefId != null && $event.item.masterRefId != undefined && $event.item.masterRefId > 0) || DGClientExists;
        this.engagementClient = clientName;
        this.isClientSelected = true;
        this.getClientUsers($event.item.clientId);
        if (this.engagementNameChanged.observers.length !== 0) {
            this.checkEngagementName();
        }
    }

    onboardClientClick() {
        let url = 'https://spo-global.kpmg.com/sites/GO-OI-SVC-Tax-and-Legal-Digital-Gateway/SitePages/DG-RequestCenter.aspx';
        window.open(url, '_blank');
    }

    goToDgClick() {
        let url = 'https://qa.digitalgateway.kpmgservicesqa.tech/mygateway/en-US/home';
        window.open(url, '_blank');
    }

    // Create Engagement
    createStudy(): void {
        this.rightSideDrawerService.spinnerLoad(true);
        this.createEngagementFormSubmitCount = ++this.createEngagementFormSubmitCount;
        this.isDisabled = false;
        let engagement: Engagement = this.targetForm.value;

        let emailFreq = this.reminderValue;
        emailFreq === null ? (emailFreq = 0) : (emailFreq = emailFreq);
        engagement.clientName = this.engagementClient.trim();
        engagement.insertedBy = 0;
        engagement.isArchived = true;
        engagement.users = this.engagementUsers;
        engagement.reminderFrequency = emailFreq;
        engagement.engagementFlagId = this.studyFlagOptionId;
        engagement.canSMEAddProjects = this.studyConfigurationSettings.checksmetimesurveyaddproject;
        engagement.canSMEAddEmployees = this.studyConfigurationSettings.checksmetimesurveyAddEmployee;
        engagement.canSMEAddNQA = this.studyConfigurationSettings.checksmetimesurveyaddnqa;
        engagement.canSMEAddNWT = this.studyConfigurationSettings.checksmetimesurveyaddnwt;
        engagement.canSMEAddActivities = this.studyConfigurationSettings.checksmetimesurveyaddactivities;
        engagement.canSMEUploadDocument = this.studyConfigurationSettings.checksmetimesurveyupload;
        engagement.canClientManagerQreInsight = this.studyConfigurationSettings.checkclientmanagerqreinsight;
        engagement.canSMESubmitTimeSurvey = this.studyConfigurationSettings.checksmetimesurveysubmitcondition;
        engagement.canSMESubmitProjectSurvey = this.studyConfigurationSettings.checksmeprojectsurveysubmitcondition;
        engagement.isEnableAgileAnalyzer = this.studyConfigurationSettings.isEnableAgileAnalyzer;
        engagement.CanSMESubmitTimeSurveyWithDocument = this.studyConfigurationSettings.checksmetimesurveysubmitconditionwithdoc;
        engagement.CanSMESubmitTimeSurveyWithSelection = this.studyConfigurationSettings.checksmeatleastonecheckboxselectedsubmitcondition;
        engagement.canSMEUploadDocumentExpenseSurvey = this.studyConfigurationSettings.checksmeuploaddocumentexpensesurvey;
        engagement.canSMESubmitExpenseSurveyWithDocument = this.studyConfigurationSettings.checksmeexpensesurveysubmitconditionwithdoc;
        engagement.canSMEAddProjectsExpenseSurvey = this.studyConfigurationSettings.checksmeaddprojectexpensesurvey;

        engagement.engagementName = encodeText(engagement.engagementName);
        engagement.engagementNumber = encodeText(engagement.engagementNumber);

        this.kpmgUsersSelected.forEach((kpmgUsers: any) => {
            engagement.users.push(kpmgUsers);
        });

        this.clientUsersSelected.forEach((clientUsers: any) => {
            engagement.users.push(clientUsers);
        });
        engagement.engagementManager = this.engagementManagerSelectedId;
        engagement.engagementPartner = this.engagementPartnerSelectedId;
        engagement.priorYearQre = engagement.priorYearQre !== null ? engagement.priorYearQre : 0;
        engagement.taxPeriods = this.formatTaxPeriodDate();
        // engagement.isFavorite = this.isSetToFavorite;
        if (this.createEngagementFormSubmitCount === 1) {
            this._manageStudyService.CreateEngagement(engagement).subscribe((data: BaseResponse) => {
                this.rightSideDrawerService.spinnerLoad(false);
                // Refresh data table on page
                this.targetForm.reset();
                this.isDisabled = false;
                this.rightSideDrawerService.closeRightSideDrawer();
                // Go to engagement preparation
                this.engagementCreated = data;
                this._toasterService.setSuccessMessage(Messages.Home.CreateEngagementSuccess);
                this.sessionService.setSession('engagementId', data.result.engagementId.toString());
                this.sessionService.setSession('clientId', data.result.clientId.toString());
                this.sessionService.setEngagementNameAndNumber(decodeText(data.result.engagementName.toString()), decodeText(data.result.engagementNumber));
                this.sessionService.setEngagementName(decodeText(data.result.engagementName.toString()));
                this.sessionService.setSession('clientName', this.engagementClient.trim());
                this.createEngagementFormSubmitCount = 0;
                this.router.navigate([ROUTE_URL.STUDYHOME(data.result.engagementId.toString())]);
                return;
            });
        }
    }

    // Search EngagementPartner
    searchEngagementPartnerStream = (searchPhrase$: Observable<any>) =>
        searchPhrase$.pipe(
            distinctUntilChanged(), // Only continue if the current search term is different that it was before the user started typing
            tap(term => {
                // Remove "no results" message in case it was displayed from the previous search
                this.noResults = false;
            }),
            switchMap(term => {
                this.finalEngagementPartnerstrKPMG = '';
                if (term !== '' && this.isSearchKPMG === true) {
                    // Process the search term entered

                    return this.searchKPMGUsers(term).pipe(
                        switchMap(data => {

                            this.noResults = data.length === 0;
                            if (this.noResults === true) {
                                let str1 = 'Click here to add user.';
                                this.finalEngagementPartnerstrKPMG = 'user' + ' ' + term.bold() + ' not found' + ' ' + str1.italics();
                                let noData = [
                                    {
                                        email: null,
                                        isDelete: false,
                                        userName: this.finalEngagementPartnerstrKPMG,
                                    },
                                ];
                                this.engagementPartnerKPMGUser = true;
                                return of(noData);
                            } else {
                                this.engagementPartnerKPMGUser = false;
                                return of(data);
                            }
                        }),
                        catchError(() => {
                            this.noResults = true;
                            return of([]);
                        }),
                    );
                } else if (
                    term !== '' &&
                    this.isSearchKPMG === false &&
                    this.engagementClient !== 'KPMG Demo'
                ) {
                    return this.searchClientUsers(term).pipe(
                        switchMap(data => {
                            this.noResults = data.length === 0;
                            return of(data);
                        }),
                        catchError(() => {
                            this.noResults = true;
                            return of([]);
                        }),
                    );
                } else if (
                    term !== '' &&
                    this.isSearchKPMG === false &&
                    this.engagementClient === 'KPMG Demo'
                ) {
                    return this.searchDemoClientUsers(term).pipe(
                        switchMap(data => {
                            this.noResults = data.length === 0;
                            return of(data);
                        }),
                        catchError(() => {
                            this.noResults = true;
                            return of([]);
                        }),
                    );
                } else {
                    return of([]);
                    this.noResultflag = true;
                }
            }),
        )

    // Search Engagement manager Search Stream
    searchEngagementManagerStream = (searchPhrase$: Observable<any>) =>
        searchPhrase$.pipe(
            distinctUntilChanged(), // Only continue if the current search term is different that it was before the user started typing
            tap(term => {
                // Remove "no results" message in case it was displayed from the previous search
                this.noResults = false;
            }),
            switchMap(term => {
                this.finalEngagementManagerstrKPMG = '';
                if (term !== '' && this.isSearchKPMG === true) {
                    // Process the search term entered
                    let str1 = 'Click here to add user.';
                    this.finalEngagementManagerstrKPMG =
                        'user' + ' ' + term.bold() + ' not found' + ' ' + str1.italics();
                    return this.searchKPMGUsers(term).pipe(
                        switchMap(data => {
                            let noData = [
                                {
                                    email: null,
                                    isDelete: false,
                                    userName: this.finalEngagementManagerstrKPMG,
                                },
                            ];
                            this.noResults = data.length === 0;
                            if (this.noResults === true) {
                                this.engagementManagerKPMGUser = true;
                                return of(noData);
                            } else {
                                this.engagementManagerKPMGUser = false;
                                return of(data);
                            }
                        }),
                        catchError(() => {
                            this.noResults = true;
                            return of([]);
                        }),
                    );
                } else if (
                    term !== '' &&
                    this.isSearchKPMG === false &&
                    this.engagementClient !== 'KPMG Demo'
                ) {
                    return this.searchClientUsers(term).pipe(
                        switchMap(data => {
                            this.noResults = data.length === 0;
                            return of(data);
                        }),
                        catchError(() => {
                            this.noResults = true;
                            return of([]);
                        }),
                    );
                } else if (
                    term !== '' &&
                    this.isSearchKPMG === false &&
                    this.engagementClient === 'KPMG Demo'
                ) {
                    return this.searchDemoClientUsers(term).pipe(
                        switchMap(data => {
                            this.noResults = data.length === 0;
                            return of(data);
                        }),
                        catchError(() => {
                            this.noResults = true;
                            return of([]);
                        }),
                    );
                } else {
                    return of([]);
                    this.noResultflag = true;
                }
            }),
        )

    // Search KPMG User and Client User
    searchUserStream = (searchPhrase$: Observable<any>) =>
        searchPhrase$.pipe(
            distinctUntilChanged(), // Only continue if the current search term is different that it was before the user started typing
            tap(term => {
                // Remove "no results" message in case it was displayed from the previous search
                this.noResults = false;
            }),
            switchMap(term => {
                if (term !== '' && this.isSearchKPMG === true) {
                    // Process the search term entered
                    let str1 = 'Click here to add user.';
                    this.finalAddKPMGUserstrKPMG =
                        'user' + ' ' + term.bold() + ' not found' + ' ' + str1.italics();
                    return this.searchKPMGUsers(term).pipe(
                        switchMap(data => {
                            let noData = [
                                {
                                    email: null,
                                    isDelete: false,
                                    userName: this.finalAddKPMGUserstrKPMG,
                                },
                            ];
                            this.noResults = data.length === 0;
                            if (this.noResults === true) {
                                this.engagementAddKPMGUser = true;
                                return of(noData);
                            } else {
                                this.engagementAddKPMGUser = false;
                                return of(data);
                            }
                        }),
                        catchError(() => {
                            this.noResults = true;
                            return of([]);
                        }),
                    );
                } else if (
                    term !== '' &&
                    this.isSearchKPMG === false &&
                    this.engagementClient !== 'KPMG Demo'
                ) {
                    return this.searchClientUsers(term).pipe(
                        switchMap(data => {
                            this.noResults = data.length === 0;
                            return of(data);
                        }),
                        catchError(() => {
                            this.noResults = true;
                            return of([]);
                        }),
                    );
                } else if (
                    term !== '' &&
                    this.isSearchKPMG === false &&
                    this.engagementClient === 'KPMG Demo'
                ) {
                    return this.searchDemoClientUsers(term).pipe(
                        switchMap(data => {
                            this.noResults = data.length === 0;
                            return of(data);
                        }),
                        catchError(() => {
                            this.noResults = true;
                            return of([]);
                        }),
                    );
                } else {
                    return of([]);
                    this.noResultflag = true;
                }
            }),
        )

    // filter KPMG Users autosuggest
    private searchKPMGUsers(term: any): Observable<any> {
        if (this.kpmgUsers.result) {
            return of(
                this.kpmgUsers.result.filter(item =>
                    item.displayName.toLowerCase().includes(term.toLowerCase()),
                ),
            );
        } else {
            return of([]);
        }
    }

    private searchDemoClientUsers(term: any): Observable<any> {
        if (this.kpmgUsers.result || this.clientUsers) {
            let kpmgUserdata: any[] = this.kpmgUsers.result;
            let clientUserData: any[] = this.clientUsers;
            this.demoClientUsers = kpmgUserdata.concat(clientUserData);
            if (kpmgUserdata != null && clientUserData != null) {
                return of(
                    this.demoClientUsers.filter(item =>
                        item.displayName.toLowerCase().includes(term.toLowerCase()),
                    ),
                );
            } else if (kpmgUserdata != null && clientUserData == null) {
                return of(
                    kpmgUserdata.filter(item =>
                        item.displayName.toLowerCase().includes(term.toLowerCase()),
                    ),
                );
            } else {
                return of(
                    clientUserData.filter(item =>
                        item.displayName.toLowerCase().includes(term.toLowerCase()),
                    ),
                );
            }
        } else {
            return of([]);
        }
    }

    // On Engagement Partner selection
    onEngagementPartnerSelect($event: any) {
        let user = $event.item;
        if (user.userName.includes('Click here to add user.')) {
            //this.showAddUserModel = true;
            this._clientUserService.setFunctionTypeAndData(false, true, null);
            this.rightSideDrawerService.openRightSideDrawer('add-user-form');
            this.rightSideDrawerService.setIsSearchKPMG(this.isSearchKPMG);
            this.rightSideDrawerService.setIsFromCreateStudy(true);
        } else {
            this.engagementPartnerSelectedId = user.userId;
            let engagementUser = {
                userName: user.userName,
                firstName: user.firstName,
                lastName: user.lastName,
                displayName: user.displayName,
                email: user.email,
                userId: user.userId,
                roleId: role.admin,
            };
            this.engagementPartnerSelected = [];
            this.engagementPartnerSelected.push(engagementUser);
        }
    }

    removeEngagementPartnerSelected(row: any) {
        this.engagementPartnerSelectedId = 0;
        let removeIndex = this.engagementPartnerSelected.findIndex(
            item => item.userId === row.userId,
        );
        this.engagementPartnerSelected.splice(removeIndex, 1);
        this.engagementPartnerSelected = [...this.engagementPartnerSelected];
    }

    // On Engagement manager selection
    onEngagementManagerSelect($event: any) {
        let user = $event.item;
        if (user.userName.includes('Click here to add user.')) {
            this._clientUserService.setFunctionTypeAndData(false, true, null);
            this.rightSideDrawerService.openRightSideDrawer('add-user-form');
            this.rightSideDrawerService.setIsSearchKPMG(this.isSearchKPMG);
            this.rightSideDrawerService.setIsFromCreateStudy(true);
        } else {
            let user = $event.item;
            this.engagementManagerSelectedId = user.userId;
            let engagementUser = {
                userName: user.userName,
                firstName: user.firstName,
                lastName: user.lastName,
                displayName: user.displayName,
                email: user.email,
                userId: user.userId,
                roleId: role.admin,
            };
            this.engagementManagerSelected = [];
            this.engagementManagerSelected.push(engagementUser);
        }

    }

    removeEngagementManagerSelected(row: any) {
        this.engagementManagerSelectedId = 0;
        let removeIndex = this.engagementManagerSelected.findIndex(
            item => item.userId === row.userId,
        );
        this.engagementManagerSelected.splice(removeIndex, 1);
        this.engagementManagerSelected = [...this.engagementManagerSelected];
    }

    // On KPMG user selection
    onKPMGUserSelect($event: any) {
        const user = $event.item;
        if (user.userName.includes('Click here to add user.')) {
            //this.showAddUserModel = true;
            this._clientUserService.setFunctionTypeAndData(false, true, null);
            this.rightSideDrawerService.openRightSideDrawer('add-user-form');
            this.rightSideDrawerService.setIsSearchKPMG(this.isSearchKPMG);
            this.rightSideDrawerService.setIsFromCreateStudy(true);
        }
        else {
            const engagementUser = {
                userId: user.userId,
                userName: user.userName,
                firstName: user.firstName,
                lastName: user.lastName,
                displayName: user.displayName,
                email: user.email,
                roleId: role.admin,
                clientId: user.clientId
            };

            const index = this.kpmgUsersSelected.findIndex(
                item => item.userId === engagementUser.userId
            );
            if (index !== -1) {
                return;
            }
            this.kpmgUsersSelected.push(engagementUser);
            this.sortedUsers();
            this.kpmgUsersSelected = [...this.kpmgUsersSelected];

            if (!this.isCreateStudy) {
                const found = this.kpmgUsersSelectedbckup.some(
                    el => el.userId === engagementUser.userId
                );
                if (
                    found &&
                    this.kpmgUsersSelectedbckup.length === this.kpmgUsersSelected.length
                ) {
                    this.changed['KPMG'] = false;
                } else {
                    this.changed['KPMG'] = true;
                }
                this.isChanged();
            }
        }

    }

    removeKPMGUser(row: any) {
        const removeIndex = this.kpmgUsersSelected.findIndex(
            item => item.userId === row.userId
        );
        this.kpmgUsersSelected.splice(removeIndex, 1);
        this.kpmgUsersSelected = [...this.kpmgUsersSelected];
        if (!this.isCreateStudy) {
            let found = true;
            this.kpmgUsersSelectedbckup.forEach(element => {
                if (!this.kpmgUsersSelected.some(el => el.userId === element.userId)) {
                    found = false;
                }
            });
            if (
                found &&
                this.kpmgUsersSelectedbckup.length === this.kpmgUsersSelected.length
            ) {
                this.changed['KPMG'] = false;
            } else {
                this.changed['KPMG'] = true;
            }
            this.isChanged();
        }
    }

    // On KPMG user selection
    onClientUserSelect($event: any) {
        let user = $event.item;

        if (user.userName.includes('Click here to add user.')) {
            this._clientUserService.setFunctionTypeAndData(false, true, null);
            this.rightSideDrawerService.openRightSideDrawer('add-user-form');
            this.rightSideDrawerService.setIsSearchKPMG(this.isSearchKPMG);
            this.rightSideDrawerService.setIsFromCreateStudy(true);
        } else {

            let engagementUser = {
                userName: user.userName,
                firstName: user.firstName,
                lastName: user.lastName,
                displayName: user.displayName,
                email: user.email,
                userId: user.userId,
                roleId: role.clientManager,
            };

            let index = this.clientUsersSelected.findIndex(
                item => item.userId === engagementUser.userId,
            );
            if (index !== -1) {
                return;
            }

            this.clientUsersSelected.push(engagementUser);
            this.clientUsersSelected = [...this.clientUsersSelected];
        }
    }

    removeClientUser(row: any) {
        let removeIndex = this.clientUsersSelected.findIndex(
            item => item.userId === row.userId,
        );
        this.clientUsersSelected.splice(removeIndex, 1);
        this.clientUsersSelected = [...this.clientUsersSelected];
    }

    showClientUsers(text: any) {
        if (text) {
            if (this.isClientMode) {
                this.engagementClient = text;
            }
            this.clientUsersSelected = [];
            let index = this.clients.result.findIndex(
                item => item.clientName.toLowerCase() === text.toLowerCase(),
            );
            if (index !== -1) {
                this.getClientUsers(this.clients.result[index].clientId);
                //this.checkEngagementName();
            } else {
                this.clientUsers = null;
            }
        }
    }

    checkIfDGClient(text: any){
        this.isDGclient = this.clients.result.filter(item => item.clientName.toLowerCase() === text.toLowerCase() && (item.masterRefId !== 0 && item.masterRefId !== null && item.masterRefId !== undefined)).length > 0;
    }

    //Based on the entered Client Name, verifies if a client with that name already exists. If it does, verifies if an entered engagement name already exists under that client.
    verifyClientWithID(clientName: string) {
        if (clientName) {
            if (this.isClientMode) {
                this.engagementClient = clientName;
            }
            this.clientUsersSelected = [];
            let index = this.clients.result.findIndex(item => item.clientName.toLowerCase() === clientName.toLowerCase());
            if (index !== -1) {
                this.getClientUsers(this.clients.result[index].clientId);
                this.checkEngagementName();
            } else {
                this.clientIdSelected = 0;
                this.clientUsers = null;
                this.engagementNameError = false;
            }
        }
    }

    trimSpecialChar(ctrl: any) {
        const ctrlVal = this.targetForm.get(ctrl).value;
        if (ctrlVal) {
            this.targetForm?.controls[ctrl].setValue(
                ctrlVal.replace(/[^a-zA-Z0-9-()._/ ]/g, ''),
            );
        }
    }

    onfocStartDate() {
        setTimeout(() => {
            this.isTaxPeriodLoad = true;
            this.dpStart?.show();
        }, 50);
    }

    onfocEndDate() {
        setTimeout(() => {
            this.isTaxPeriodLoad = true;
            this.dpEnd?.show();
        }, 50);
    }

    onfocEF() {
        this.dpEnd.hide();
    }

    openDatePickerEnd() {
        this.dpEnd.toggle();
    }

    openDatePickerStart() {
        this.dpStart.toggle();
    }
    onCancelEdit() {
        this.router.navigate([ROUTE_URL.STUDYHOME(this.engagementId.toString())]);
    }
    onCancel() {
        this.router.navigate(['/home']);
    }

    setReminder(value) {
        ;
    }

    flagOptionClick(optionId: number) {
        if (this.isCreateStudy) {
            this.studyFlagOptionId = optionId;
            if (this.studyFlagOptionId === this.engagementFlag.Demo) {
                this.targetForm.get('engagementNumber').setValidators(this.engagementNumberValidators.demoEngagement);
                this.isDemoClickedFirst = true;
                this.targetForm.patchValue({ clientName: 'AMCS Demo' });
                this.defaultClientName.nativeElement.value = "AMCS Demo"
                this.engagementClient = "AMCS Demo";
                let today = new Date();
                let monDate = formatDate(today, 'shortDate', 'en-US').replace(/\//g, '').substring(0, 4);
                let time = formatDate(today, 'mediumTime', 'en-US').substring(0, 7).replace(/:/g, '');
                let formatedDate = formatDate(today, 'mediumDate', 'en-US').replace(',', '');
                this.targetForm.patchValue({ engagementName: 'AMCS Demo - ' + formatedDate });
                this.targetForm.patchValue({ engagementNumber: 'Demo' + monDate + time });
                this.engagementPartnerSelectedId = this.user.userId;
                this.engagementManagerSelectedId = this.user.userId;
                this.userDetails = this.kpmgUsers.result.find(x => x.userId === this.user.userId);
                let engagementUser = {
                    userName: this.userDetails.userName,
                    firstName: this.userDetails.firstName,
                    lastName: this.userDetails.lastName,
                    displayName: this.userDetails.displayName,
                    email: this.userDetails.email,
                    userId: this.userDetails.userId,
                    roleId: role.admin,
                };
                this.engagementManagerSelected = [];
                this.engagementManagerSelected.push(this.userDetails);
                this.engagementPartnerSelected = [];
                this.engagementPartnerSelected.push(engagementUser);
                this.emailReminderText = "Every 3 days";
                this.reminderValue = 3;

            } else if (this.isDemoClickedFirst) {
                this.targetForm.get('engagementNumber').setValidators(this.engagementNumberValidators.liveEngagement);
                this.targetForm.reset();
                this.targetForm.patchValue({ clientName: '' });
                this.targetForm.patchValue({ engagementName: '' });
                this.targetForm.patchValue({ engagementNumber: '' });
                this.defaultClientName.nativeElement.value = ""
                this.emailReminderText = 'No reminders';
                this.reminderValue = 0;
                this.targetForm.patchValue({ totalHours: '2096' });
                this.targetForm.patchValue({ standardNonWorkingHours: '120' });
                this.engagementManagerSelected = [];
                this.engagementPartnerSelected = [];
                this.engagementManagerSelectedId = 0;
                this.engagementPartnerSelectedId = 0;
            }
        }
        else {
            this.studyFlagOptionId = optionId;
            if (this.studyFlagOptionId === this.engagementFlag.Demo) {
                this.targetForm.get('engagementNumber').setValidators(this.engagementNumberValidators.demoEngagement);
            } else if (this.studyFlagOptionId === this.engagementFlag.Live) {
                this.targetForm.get('engagementNumber').setValidators(this.engagementNumberValidators.liveEngagement);
            }
            this.targetForm.get('engagementNumber').updateValueAndValidity();
            this.isDisabled = false;
        }
    }



    onRCSWatsonSelect() {
        this.RCSWatsonTouched = true;
        let questions = this.RCSWatsonData.sort(i => i.questionOrder);
        this.questiondata = questions.filter(function (elem, index, self) {
            return index === self.indexOf(elem);

        });
        let uniq = {};
        this.questiondata = questions.filter(obj => !uniq[obj.questionID] && (uniq[obj.questionID] = true));


        this.RCSWatsonQuestion[0] = false;
        this.RCSWatsonQuestion[1] = false;
        this.RCSWatsonQuestion[2] = false;

        this.RCSWatsonCount = 0;

        this.isChanged();
    }

    onRCSContractSelect() {
        this.RCSContractTouched = true;
        let questions = this.RCSContractData.sort(i => i.questionOrder);
        this.questiondataContract = questions.filter(function (elem, index, self) {
            return index === self.indexOf(elem);

        });
        let uniq = {};
        this.questiondataContract = questions.filter(obj => !uniq[obj.questionID] && (uniq[obj.questionID] = true));


        this.RCSContractQuestion[0] = false;
        this.RCSContractQuestion[1] = false;

        this.isChanged();
    }

    studyConfiguration(event, studyInputConfiguration: string) {
        let status = event;
        switch (studyInputConfiguration) {
            case "clientmanagerqreinsight":
                this.studyConfigurationSettings.checkclientmanagerqreinsight = status;
                break;
            case "smetimesurveyupload":
                if (this.studyConfigurationSettings.checksmetimesurveysubmitconditionwithdoc && !status) {
                    this.studyConfigurationSettings.checksmetimesurveysubmitconditionwithdoc = false;
                }
                this.studyConfigurationSettings.checksmetimesurveyupload = status;
                break;
            case "smetimesurveyAddEmployee":
                this.studyConfigurationSettings.checksmetimesurveyAddEmployee = status;
                break;
            case "smetimesurveyaddproject":
                this.studyConfigurationSettings.checksmetimesurveyaddproject = status;
                break;
            case "smetimesurveyaddactivities":
                this.studyConfigurationSettings.checksmetimesurveyaddactivities = status;
                break;
            case "smetimesurveyaddnqa":
                this.studyConfigurationSettings.checksmetimesurveyaddnqa = status;
                break;
            case "smetimesurveyaddnwt":
                this.studyConfigurationSettings.checksmetimesurveyaddnwt = status;
                break;
            case "smetimesurveysubmitcondition":
                this.studyConfigurationSettings.checksmetimesurveysubmitcondition = status;
                break;
            case "smeprojectsurveysubmitcondition":
                this.studyConfigurationSettings.checksmeprojectsurveysubmitcondition = status;
                break;
            case "isenableagileanalyzer":
                this.studyConfigurationSettings.isEnableAgileAnalyzer = status;
                break;
            case "smetimesurveysubmitconditionwithdocument":
                this.studyConfigurationSettings.checksmetimesurveysubmitconditionwithdoc = status;
                if (status) {
                    this.studyConfigurationSettings.checksmetimesurveyupload = status;
                }
                break;
            case "checksmeatleastonecheckboxselectedsubmitcondition":
                this.studyConfigurationSettings.checksmeatleastonecheckboxselectedsubmitcondition = status;
                break;
            case "smeuploaddocumentexpensesurvey":
                if (this.studyConfigurationSettings.checksmeexpensesurveysubmitconditionwithdoc && !status) {
                    this.studyConfigurationSettings.checksmeexpensesurveysubmitconditionwithdoc = false;
                }
                this.studyConfigurationSettings.checksmeuploaddocumentexpensesurvey = status;
                break;
            case "smeaddprojectexpensesurvey":
                this.studyConfigurationSettings.checksmeaddprojectexpensesurvey = status;
                break;
            case "smeexpensesurveysubmitconditionwithdocument":
                this.studyConfigurationSettings.checksmeexpensesurveysubmitconditionwithdoc = status;
                if (status) {
                    this.studyConfigurationSettings.checksmeuploaddocumentexpensesurvey = status;
                }
                break;
        }
        this.isDisabled = false;
    }

    updateEngagement() {
        this.engagementUsers = [];
        this._loaderService.display(true, true);
        this.isDisabled = true;
        this.kpmgUsersSelected.forEach((kpmgUsers: any) => {
            this.engagementUsers.push(kpmgUsers);
        });

        this.clientUsersSelected.forEach((clientUsers: any) => {
            let clientUser = {
                clientId: clientUsers.clientId,
                displayName: clientUsers.displayName,
                email: clientUsers.email,
                firstName: clientUsers.firstName,
                insertedBy: this.user.userId,
                lastName: clientUsers.lastName,
                roleId: role.clientManager,
                updatedBy: this.user.userId,
                userId: clientUsers.userId,
                userName: clientUsers.userName
            }
            this.engagementUsers.push(clientUser);
        });
        this.clientAdminSelected.forEach((clientUsers: any) => {
            let clientUser = {
                clientId: clientUsers.clientId,
                displayName: clientUsers.displayName,
                email: clientUsers.email,
                firstName: clientUsers.firstName,
                insertedBy: this.user.userId,
                lastName: clientUsers.lastName,
                roleId: role.clientAdmin,
                updatedBy: this.user.userId,
                userId: clientUsers.userId,
                userName: clientUsers.userName
            }
            this.engagementUsers.push(clientUser);
        });
        let removeCA: any[] = [];
        this.removeClientAdminSelected.forEach((clientUsers: any) => {
            let clientUser = {
                clientId: clientUsers.clientId,
                displayName: clientUsers.displayName,
                email: clientUsers.email,
                firstName: clientUsers.firstName,
                insertedBy: this.user.userId,
                lastName: clientUsers.lastName,
                roleId: role.clientAdmin,
                updatedBy: this.user.userId,
                userId: clientUsers.userId,
                userName: clientUsers.userName
            }
            removeCA.push(clientUser);
        });

        /*this.clientUsersSelected.forEach((clientUsers: any) => {
            this.engagementUsers.push(clientUsers);
        });*/

        const engagement = {
            engagementId: this.engagementId,
            engagementNumber: encodeText(this.targetForm.get('engagementNumber').value),
            engagementName: encodeText(this.targetForm.get('engagementName').value),
            updatedOn: new Date(),
            reminderFrequency: this.reminderValue,
            users: this.engagementUsers,
            removeClientAdminUsers: removeCA,
            updatedBy: this.user.userId,
            isArchived: this.check,
            RCSDocumentAnalysis: this.RCSquestiondata,
            RCSWatson: this.enableRCSWatson,
            RCSContract: this.enableRCSContract,
            engagementManager: this.engagementManagerSelectedId,
            engagementPartner: this.engagementPartnerSelectedId,
            taxYear: this.taxYear,
            engagementFlagId: this.studyFlagOptionId,
            clientId: this.clientId,
            totalHours: this.targetForm.get('totalHours').value,
            standardNonWorkingHours: this.targetForm.get('standardNonWorkingHours').value,
            canSMEAddProjects: this.studyConfigurationSettings.checksmetimesurveyaddproject,
            canSMEAddEmployees: this.studyConfigurationSettings.checksmetimesurveyAddEmployee,
            canSMEAddNQA: this.studyConfigurationSettings.checksmetimesurveyaddnqa,
            canSMEAddNWT: this.studyConfigurationSettings.checksmetimesurveyaddnwt,
            canSMEAddActivities: this.studyConfigurationSettings.checksmetimesurveyaddactivities,
            canSMEUploadDocument: this.studyConfigurationSettings.checksmetimesurveyupload,
            canClientManagerQreInsight: this.studyConfigurationSettings.checkclientmanagerqreinsight,
            canSMESubmitTimeSurvey: this.studyConfigurationSettings.checksmetimesurveysubmitcondition,
            canSMESubmitProjectSurvey: this.studyConfigurationSettings.checksmeprojectsurveysubmitcondition,
            CanSMESubmitTimeSurveyWithSelection: this.studyConfigurationSettings.checksmeatleastonecheckboxselectedsubmitcondition,
            isEnableAgileAnalyzer: this.studyConfigurationSettings.isEnableAgileAnalyzer,
            priorYearQre: this.targetForm.get('priorYearQre').value !== null ? this.targetForm.get('priorYearQre').value : 0,
            canSMESubmitTimeSurveyWithDocument: this.studyConfigurationSettings.checksmetimesurveysubmitconditionwithdoc,
            canSMEUploadDocumentExpenseSurvey: this.studyConfigurationSettings.checksmeuploaddocumentexpensesurvey,
            canSMESubmitExpenseSurveyWithDocument: this.studyConfigurationSettings.checksmeexpensesurveysubmitconditionwithdoc,
            canSMEAddProjectsExpenseSurvey: this.studyConfigurationSettings.checksmeaddprojectexpensesurvey,
            taxPeriods: this.formatTaxPeriodDate(),
            // isFavoriteStudy: this.isSetToFavorite
        };

        this._manageStudyService.UpdateEngagement(engagement).subscribe(
            (data: BaseResponse) => {
                if (data !== null && data.success) {

                    this.sessionService.setSession('engagementId', data.result.engagementId.toString());
                    this.sessionService.setSession('clientId', data.result.clientId.toString());
                    this.sessionService.setEngagementNameAndNumber(decodeText(data.result.engagementName.toString()), decodeText(data.result.engagementNumber.toString()));
                    this.sessionService.setEngagementName(decodeText(data.result.engagementName.toString()));

                    this._loaderService.display(false);
                    this._toasterService.setSuccessMessage(
                        Messages.Home.ClientUserSelectionAdd
                    );
                    this.router.navigate([ROUTE_URL.STUDYHOME(this.engagementId.toString())]);
                } else {
                    this._loaderService.display(false);
                    this.isDisabled = true;
                    this._toasterService.setErrorMessage(
                        Messages.Home.UpdateEngagementFailure
                    );
                }
            });
    }

    RCSWatsonChange(ans, index, id) {
        let RCSquestiondata = {
            questionID: id,
            ans: ans
        };
        if (this.RCSquestiondata && this.RCSquestiondata.find(x => x.questionID === id)) {


            this.RCSquestiondata.find(x => x.questionID == id).ans = ans;
        } else {
            this.RCSquestiondata.push(RCSquestiondata);

        }

        this.RCSWatsonData = JSON.parse(JSON.stringify(this.RCSWatsonDataDup));
        if (ans === 'yes') {
            if (this.RCSWatsonCount < 3 && !this.questiondata[index].ans) {
                this.RCSWatsonCount++;
            }
            this.RCSWatsonvalues[String(id)] = false;
            let message = this.RCSWatsonData.find(x => x.questionID === id && x.answer === 'Yes');

            this.RCSWatsonQuestion[index] = true;
            this.questiondata[index].ans = true;
            this.questiondata[index].message = message.message;

        }
        if (ans === 'no') {
            if (this.RCSWatsonCount < 3 && !this.questiondata[index].ans) {
                this.RCSWatsonCount++;
            }
            this.RCSWatsonvalues[String(id)] = true;
            let message = this.RCSWatsonData.find(x => x.questionID === id && x.answer === 'No');

            this.RCSWatsonQuestion[index] = false;
            this.questiondata[index].ans = true;
            this.questiondata[index].message = message.message;
        }

        if (ans === 'notsure') {
            if (this.RCSWatsonCount < 3 && !this.questiondata[index].ans) {
                this.RCSWatsonCount++;
            }
            this.RCSWatsonvalues[String(id)] = false;
            let message = this.RCSWatsonData.find(x => x.questionID === id && x.answer === 'NotSure');
           
            this.RCSWatsonQuestion[index] = true;
            this.questiondata[index].ans = true;
            this.questiondata[index].message = message.message;
        }
        this.determineRCSEnable();
    }

    determineRCSEnable() {

        if (this.RCSWatsonvalues['3'] === true && this.RCSWatsonvalues['1'] === true && this.RCSWatsonCount === 3) {
            this.enableRCSWatson = true;
            if (!this.isCreateStudy) {
                this.isDisabled = false;
            }
        } else if (this.RCSWatsonvalues['3'] === false || this.RCSWatsonvalues['1'] === false) {
            this.enableRCSWatson = false;
        }
    }
    RCSContractChange(ans, index, id) {
        let RCSquestiondata = {
            questionID: id,
            ans: ans
        };
        if (this.RCSquestiondata && this.RCSquestiondata.find(x => x.questionID === id)) {

           
            this.RCSquestiondata.find(x => x.questionID == id).ans = ans;
        } else {
            this.RCSquestiondata.push(RCSquestiondata);
        }
        this.RCSContractData = JSON.parse(JSON.stringify(this.RCSContractDataDup));
        if (ans === 'yes') {
            if (this.RCSContractcount < 2 && !this.questiondataContract[index].ans) {
                this.RCSContractcount++;
            }
            this.RCSContractvalues[String(id)] = false;
            let message = this.RCSContractData.find(x => x.questionID === id && x.answer === 'Yes');
            
            this.RCSContractQuestion[index] = true;
            this.questiondataContract[index].ans = true;
            this.questiondataContract[index].message = message.message;

        }
        if (ans === 'no') {
            if (this.RCSContractcount < 2 && !this.questiondataContract[index].ans) {
                this.RCSContractcount++;
            }
            this.RCSContractvalues[String(id)] = true;
            let message = this.RCSContractData.find(x => x.questionID === id && x.answer === 'No');
        
            this.RCSContractQuestion[index] = true;
            this.questiondataContract[index].ans = true;
            this.questiondataContract[index].message = message.message;
        }

        if (ans === 'notsure') {
            if (this.RCSContractcount < 2 && !this.questiondataContract[index].ans) {
                this.RCSContractcount++;
            }
            this.RCSContractvalues[String(id)] = false;
            let message = this.RCSContractData.find(x => x.questionID === id && x.answer === 'NotSure');
           
            this.RCSContractQuestion[index] = true;
            this.questiondataContract[index].ans = true;
            this.questiondataContract[index].message = message.message;
        }
        this.determineRCSContractEnable();
    }
    determineRCSContractEnable() {

        if (this.RCSContractvalues['4'] === true && this.RCSContractcount === 2) {
            this.enableRCSContract = true;
            if (!this.isCreateStudy) {
                this.isDisabled = false;
            }
        } else if (this.RCSContractcount === 2) {
            this.enableRCSContract = false;
        }
    }

    masterCheckboxaction = event => {
        if (event === true) {
            this.check = event;
        } else {
            this.check = false;
        }
        this.isChanged();
    };

    allowSMEsToAddNewProjectsEvent(event: any) {
        this.canSMEAddProjects = event.target.checked
    }

    allowSMEsToAddNewEmployeesEvent(event: any) {
        this.canSMEAddEmployees = event.target.checked
    }

    _keyUp(event: any) {
        const pattern = /[0-9\.\-\ ]/;
        let inputChar = String.fromCharCode(event.key);

        if (!pattern.test(inputChar)) {
            // invalid character, prevent input
            event.preventDefault();
            if (!this.isCreateStudy) {
                this.isDisabled = false;
            }
        }
    }

    navigateToSurveyScreen(select: string) {
        this.isTaxPeriodLoad = false;
        switch (select) {
            case "selectStudyDetails":
                this.selectedTab.selectStudyDetails = true;
                this.selectedTab.selectTaxYear = false;
                this.selectedTab.selectStudyConfiguration = false;
                this.selectedTab.selectAccessPermission = false;
                this.selectedTab.selectClientUsers = false;
                break;
            case "selectTaxYear":
                this.selectedTab.selectTaxYear = true;
                this.selectedTab.selectStudyDetails = false;
                this.selectedTab.selectStudyConfiguration = false;
                this.selectedTab.selectAccessPermission = false;
                this.selectedTab.selectClientUsers = false;
                break;
            case "selectStudyConfiguration":
                this.selectedTab.selectStudyDetails = false;
                this.selectedTab.selectTaxYear = false;
                this.selectedTab.selectStudyConfiguration = true;
                this.selectedTab.selectAccessPermission = false;
                this.selectedTab.selectClientUsers = false;
                break;
            case "selectAccessPermission":
                this.selectedTab.selectStudyDetails = false;
                this.selectedTab.selectTaxYear = false;
                this.selectedTab.selectStudyConfiguration = false;
                this.selectedTab.selectAccessPermission = true;
                this.selectedTab.selectClientUsers = false;
                break;
            case "selectClientUsers":
                this.selectedTab.selectStudyDetails = false;
                this.selectedTab.selectTaxYear = false;
                this.selectedTab.selectStudyConfiguration = false;
                this.selectedTab.selectAccessPermission = false;
                this.selectedTab.selectClientUsers = true;
                break;
        }
    }

    updateClientManager(event): void {
        this.clientUsersSelected = event;
        this.isDisabled = false;
    }

    updateClientAdmin(event): void {
        this.clientAdminSelected = event;
        this.isDisabled = false;
    }

    removeClientAdmin(event): void {
        this.removeClientAdminSelected = event;
    }


    onContinue() {
        if (this.selectedTab.selectStudyDetails) {
            let value =
                this.targetForm?.controls.engagementNumber.value ||
                this.targetForm?.controls.clientName.value ||
                this.targetForm?.controls.engagementName.value ||
                this.engagementManagerSelectedId > 0 ||
                this.engagementPartnerSelectedId > 0;
            if (value) {
                var taxPeriod = this.taxTargetForm.getRawValue().taxPeriodsFormArray.at(0);
                var errors = this.taxTargetForm.getRawValue().taxPeriodsFormArray.filter(x => x.dateError || x.taxNameError);
                this.isTaxPeriodReady = false;
                if (!taxPeriod.taxPeriodName || !taxPeriod.startDate || !taxPeriod.endDate || errors.length > 0 || taxPeriod.employeeWorkingHourThreshold > 8784) {
                    this.isTaxPeriodReady = true;
                }
                var incompleteTaxPeriod = this.taxTargetForm.getRawValue().taxPeriodsFormArray.filter(x => (!x.taxPeriodName || !x.startDate || !x.endDate || x.employeeWorkingHourThreshold > 8784) &&
                    (x.estimatedQRE || x.baseYear || x.taxPeriodName || x.startDate || x.endDate));
                if (incompleteTaxPeriod.length > 0) {
                    this.isTaxPeriodReady = true;
                }

                this.navigationString = "selectTaxYear";
            }
        }
        if (this.selectedTab.selectTaxYear) {
            this.navigationString = "selectStudyConfiguration";
        }
        if (this.selectedTab.selectStudyConfiguration) {
            this.navigationString = "selectAccessPermission";
            this.readyToSubmitStudy();
        }
        if (this.selectedTab.selectAccessPermission) {
            let value = this.kpmgUsersSelected.length > 0
            if (value) {
                this.navigationString = "readyToSubmit";
            }
        }
        switch (this.navigationString) {
            case "selectStudyDetails":
            case "selectTaxYear":
            case "selectStudyConfiguration":
            case "selectAccessPermission":
                this.navigateToSurveyScreen(this.navigationString);
                break;
            case "readyToSubmit":
                this.readyToSubmit = true;
                break;
            default:
                break;
        }
    }

    readyToSubmitStudy() {
        let value =
            this.targetForm?.controls.engagementNumber.value ||
            this.targetForm?.controls.clientName.value ||
            this.targetForm?.controls.engagementName.value ||
            this.engagementManagerSelectedId > 0 ||
            this.engagementPartnerSelectedId > 0 ||
            this.kpmgUsersSelected.length > 0
        if (value) {
            this.readyToSubmit = true;
        }
    }
    taxPeriodNameChange(index) {
        this.validateDuplicateTaxPeriod();
        this.validateTaxPeriod(index);
    }
    validateDuplicateTaxPeriod() {
        const formArray = <FormArray>this.taxTargetForm?.controls['taxPeriodsFormArray'];

        const tax = this.taxTargetForm.getRawValue().taxPeriodsFormArray;
        tax.forEach(element => {
            var duplicateValue = this.taxTargetForm.getRawValue().taxPeriodsFormArray.filter(x => x.taxPeriodName && x.taxPeriodName.toLowerCase().trim() === element.taxPeriodName.toLowerCase().trim() && element.taxPeriodName && element.taxPeriodName !== '');
            if (duplicateValue.length > 1) {
                duplicateValue.forEach(element => {
                    const rowIndex = this.taxTargetForm.getRawValue().taxPeriodsFormArray.findIndex(x => x.rowIndex === element.rowIndex);
                    formArray.controls[rowIndex].patchValue({ taxNameError: true });
                });
            } else {
                if (duplicateValue.length > 0) {
                    const rowIndex = this.taxTargetForm.getRawValue().taxPeriodsFormArray.findIndex(x => x.rowIndex === duplicateValue[0].rowIndex);
                    formArray.controls[rowIndex].patchValue({ taxNameError: false });
                }
            }
        });
    }
    updateStartDate(date, index) {
        if (this.isTaxPeriodLoad) {
            var taxPeriod = this.taxTargetForm.getRawValue().taxPeriodsFormArray;
            taxPeriod[index].startDate = date;
            const formArray = <FormArray>this.taxTargetForm.controls['taxPeriodsFormArray'];
            if (!taxPeriod[index].baseYear) {
                let endDate = JSON.parse(JSON.stringify((date === undefined && !date || isNaN(date)) ? null : date));
                endDate = (!endDate) ? null : new Date(endDate);

                endDate.setFullYear(endDate.getFullYear() + 1);
                endDate.setDate(endDate.getDate() - 1);

                this.isTaxPeriodLoad = false;
                taxPeriod[index].endDate = endDate;
                formArray.controls[index].patchValue({ endDate: endDate });
            } else {
                taxPeriod[index].endDate = taxPeriod[index].endDate ? new Date(taxPeriod[index].endDate) : taxPeriod[index].endDate;
            }
            this.validateDate(taxPeriod, index, formArray);
        }
    }
    checkLeapYear(year) {
        if ((0 == year % 4) && (0 != year % 100) || (0 == year % 400)) {
            return true;
        } else {
            return false;
        }
    }
    validateDate(taxPeriod, index, formArray) {
        formArray.controls[index].patchValue({ dateError: false });
        taxPeriod[index].dateError = false;
        if ((taxPeriod[index].startDate !== undefined && isNaN(taxPeriod[index].startDate)) || (taxPeriod[index].endDate !== undefined && isNaN(taxPeriod[index].endDate))) {
            formArray.controls[index].patchValue({ dateError: true });
            this.dateErrorMessage = 'Invalid Date Format';
            taxPeriod[index].dateError = true;
        }
        if (!taxPeriod[index].dateError && taxPeriod[index].startDate && taxPeriod[index].endDate) {
            if ((taxPeriod[index].startDate > taxPeriod[index].endDate) || (new Date(formatDate(taxPeriod[index].startDate, 'MM/dd/yyyy', 'en-US')) > new Date(formatDate(taxPeriod[index].endDate, 'MM/dd/yyyy', 'en-US')))) {
                formArray.controls[index].patchValue({ dateError: true });
                this.dateErrorMessage = 'Start Date cannot be later than End Date';
                taxPeriod[index].dateError = true;
            }
        }

        var firstRow = taxPeriod.at(0);
        var errors = taxPeriod.filter(x => x.dateError || x.taxNameError);

        if (!firstRow.taxPeriodName || !firstRow.startDate || !firstRow.endDate || errors.length > 0) {
            this.isTaxPeriodReady = true;
            if (this.engagementId) {
                this.isDisabled = true;
            }
            return;
        }

        var incompleteTaxPeriod = taxPeriod.filter(x => (!x.taxPeriodName || !x.startDate || !x.endDate || x.employeeWorkingHourThreshold > 8784) &&
            (x.estimatedQRE || x.baseYear || x.taxPeriodName || x.startDate || x.endDate));
        if (incompleteTaxPeriod.length > 0) {
            this.isTaxPeriodReady = true;
            if (this.engagementId) {
                this.isDisabled = true;
            }
            return;
        }

        if (this.engagementId) {
            this.isDisabled = false;
            return;
        }
        this.isTaxPeriodReady = false;
    }
    validateEndDate(date, index) {
        if (this.isTaxPeriodLoad) {
            var taxPeriod = this.taxTargetForm.getRawValue().taxPeriodsFormArray;
            taxPeriod[index].endDate = date;
            const formArray = <FormArray>this.taxTargetForm.controls['taxPeriodsFormArray'];
            this.validateDate(taxPeriod, index, formArray);
        }
    }
    bindTaxperiodFormArray() {
        const formArray = new FormArray([]);
        for (let i of this.taxPeriods) {
            formArray.push(
                new FormGroup({
                    'taxPeriodId': new FormControl(i.taxPeriodId),
                    'engagementId': new FormControl(!this.engagementId ? 0 : this.engagementId),
                    'taxPeriodName': new FormControl(i.taxPeriodName),
                    'startDate': new FormControl(!i.startDate ? i.startDate : new Date(i.startDate), Validators.required),
                    'endDate': new FormControl({ value: i.endDate, disabled: !i.baseYear }, Validators.required),
                    'employeeWorkingHourThreshold': new FormControl(i.employeeWorkingHourThreshold),
                    'estimatedQRE': new FormControl(i.estimatedQRE),
                    'baseYear': new FormControl(i.baseYear),
                    'rowIndex': new FormControl(i.rowIndex),
                    'dateError': new FormControl(i.dateError),
                    'taxNameError': new FormControl(i.taxNameError)
                })
            );
        }
        this.taxTargetForm = this.formBuilder.group({
            'taxPeriodsFormArray': formArray
        });
    }
    formatTaxPeriods(savedtaxPeriods) {
        for (let i = 0; i < savedtaxPeriods.length; i++) {
            this.taxPeriods.push({
                taxPeriodId: savedtaxPeriods[i].taxPeriodId,
                engagementId: savedtaxPeriods[i].engagementId,
                taxPeriodName: savedtaxPeriods[i].taxPeriodName,
                startDate: formatDate(savedtaxPeriods[i].startDate, 'MM/dd/yyyy', 'en-US'),
                endDate: formatDate(savedtaxPeriods[i].endDate, 'MM/dd/yyyy', 'en-US'),
                employeeWorkingHourThreshold: savedtaxPeriods[i].employeeWorkingHourThreshold,
                estimatedQRE: savedtaxPeriods[i].estimatedQRE,
                baseYear: savedtaxPeriods[i].baseYear,
                rowIndex: i,
                dateError: false,
                taxNameError: false
            });
        }
        this.bindTaxperiodFormArray();
    }
    getInitialTaxPeriodRow() {
        this.taxPeriods.push({
            taxPeriodId: 0,
            engagementId: 0,
            taxPeriodName: null,
            startDate: null,
            endDate: null,
            employeeWorkingHourThreshold: 2500,
            estimatedQRE: null,
            baseYear: false,
            rowIndex: 0,
            dateError: false,
            taxNameError: false
        });
    }
    baseYearClick(baseYear, index) {
        if (baseYear) {
            const formArray = <FormArray>this.taxTargetForm.controls['taxPeriodsFormArray'];
            formArray.controls[index].get('endDate').enable();
        } else {
            const formArray = <FormArray>this.taxTargetForm.controls['taxPeriodsFormArray'];
            if (formArray.controls[index].value.startDate) {
                const date = formArray.controls[index].value.startDate;
                let endDate = JSON.parse(JSON.stringify((date === undefined && !date || isNaN(date)) ? null : date));
                endDate = (!endDate) ? null : new Date(endDate);
                if (endDate !== null) {
                    const leapYear = this.checkLeapYear(endDate.getYear());
                    if (leapYear) {
                        endDate.setDate(endDate.getDate() + 365);
                    } else {
                        endDate.setDate(endDate.getDate() + 364);
                    }
                }

                formArray.controls[index].patchValue({ endDate: endDate });
            }
            formArray.controls[index].get('endDate').disable();
        }
        const formArray = <FormArray>this.taxTargetForm?.controls['taxPeriodsFormArray'];
        formArray.controls[index].patchValue({ baseYear: baseYear });
        var taxPeriod = this.taxTargetForm.getRawValue().taxPeriodsFormArray.at(index);
        taxPeriod.baseYear = baseYear;
        this.validateTaxPeriod(index);
    }
    onAddTaxPeriod() {
        this.isTaxPeriodLoad = false;
        const formArray = <FormArray>this.taxTargetForm?.controls['taxPeriodsFormArray'];
        if (formArray.controls.length <= 15) {
            formArray.push(
                new FormGroup({
                    'taxPeriodId': new FormControl(0),
                    'engagementId': new FormControl(!this.engagementId ? 0 : this.engagementId),
                    'taxPeriodName': new FormControl(null),
                    'startDate': new FormControl(null),
                    'endDate': new FormControl({ value: null, disabled: true }),
                    'employeeWorkingHourThreshold': new FormControl(2500),
                    'estimatedQRE': new FormControl(null),
                    'baseYear': new FormControl(false),
                    'rowIndex': new FormControl(formArray.controls.length),
                    'dateError': new FormControl(false),
                    'taxNameError': new FormControl(false)
                }));
        }
    }

    onDeleteTaxPeriod(index) {
        this._loaderService.display(true, true);
        const taxPeriod = this.taxTargetForm.getRawValue().taxPeriodsFormArray.filter(x => x.rowIndex === index);
        const indexNo = this.taxTargetForm.getRawValue().taxPeriodsFormArray.findIndex(x => x.rowIndex === index)
        if (taxPeriod[0].taxPeriodId > 0) {
            this._manageStudyService.deleteTaxPeriod(taxPeriod[0]).subscribe(
                (data: BaseResponse) => {
                    if (data) {
                        this._toasterService.setSuccessMessage(
                            Messages.Home.TaxPeriodDeleted,
                        );
                        this.deleteTaxPeriodRow(indexNo);
                    }
                });
        } else {
            this.deleteTaxPeriodRow(indexNo);
        }
    }
    deleteTaxPeriodRow(index) {
        const formArray = <FormArray>this.taxTargetForm?.controls['taxPeriodsFormArray'];
        formArray.removeAt(index);
        this._loaderService.display(false);
        this.validateDuplicateTaxPeriod();
        this.validateTaxPeriod(index);
    }
    validateTaxPeriod(index) {
        var taxPeriod = this.taxTargetForm.getRawValue().taxPeriodsFormArray.at(0);
        var errors = this.taxTargetForm.getRawValue().taxPeriodsFormArray.filter(x => x.dateError || x.taxNameError);

        if (!taxPeriod.taxPeriodName || !taxPeriod.startDate || !taxPeriod.endDate || errors.length > 0 || taxPeriod.employeeWorkingHourThreshold > 8784) {
            this.isTaxPeriodReady = true;
            if (this.engagementId) {
                this.isDisabled = true;
            }
            return;
        }

        var incompleteTaxPeriod = this.taxTargetForm.getRawValue().taxPeriodsFormArray.filter(x => (!x.taxPeriodName || !x.startDate || !x.endDate || x.employeeWorkingHourThreshold > 8784) &&
            (x.estimatedQRE || x.baseYear || x.taxPeriodName || x.startDate || x.endDate));
        if (incompleteTaxPeriod.length > 0) {
            this.isTaxPeriodReady = true;
            if (this.engagementId) {
                this.isDisabled = true;
            }
            return;
        }

        if (this.engagementId) {
            this.isDisabled = false;
            return;
        }

        this.isTaxPeriodReady = false;
    }

    trimTaxPeriodSpecialChar(index) {
        const formArray = <FormArray>this.taxTargetForm?.controls['taxPeriodsFormArray'];
        const taxName = formArray.controls[index].get('taxPeriodName').value;
        formArray.controls[index].patchValue({ taxPeriodName: taxName.replace(/[^a-zA-Z0-9-()._/ ]/g, '') });
    }
    get taxPeriodsFormArray() {
        return this.taxTargetForm?.controls["taxPeriodsFormArray"] as FormArray;
    }
    formatTaxPeriodDate() {
        const taxPeriod = this.taxTargetForm.getRawValue().taxPeriodsFormArray.filter(x => x.taxPeriodName && x.startDate && x.endDate);
        taxPeriod.forEach(element => {
            element.startDate = this.datepipe.transform(element.startDate, 'MM/dd/yyyy');
            element.endDate = this.datepipe.transform(element.endDate, 'MM/dd/yyyy');
            element.taxPeriodName = element.taxPeriodName.trim();
        });
        return taxPeriod;
    }

    setStudyAsFavorite(): void {
        // this.isSetToFavorite = !this.isSetToFavorite
        // if (!this.isCreateStudy)
        //     this.isDisabled = false;
    }
}


